import { useQuery } from '@tanstack/react-query';
import type { HealthResponse } from '@teentack/shared';
import { fetchHealth } from '@/lib/api-client';

export function useHealth() {
  return useQuery<HealthResponse>({
    queryKey: ['health'],
    queryFn: fetchHealth,
    refetchInterval: 15_000,
  });
}
